import React from 'react'
import { Table } from 'react-bootstrap'
import TRow from './tRow'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import isFieldHiddenSfr from '_/utils/isFieldHiddenSfr'

/**
 * Editable table for properties and transactions
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class EditableTable extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    editable: React.PropTypes.bool,
    adminEditOnly: React.PropTypes.object,
    fields: React.PropTypes.object.isRequired,
    data: React.PropTypes.object.isRequired,
    link: React.PropTypes.func.isRequired,
    errors: React.PropTypes.object,
    metadata: React.PropTypes.object.isRequired,
    title: React.PropTypes.string,
    onCertify: React.PropTypes.func.isRequired
  }

  renderTitle () {
    return this.props.title && (<h5><b>{this.props.title}</b></h5>)
  }

  checkAdminFields (field) {
    const { account, adminEditOnly } = this.props
    const isAdmin = account.get('isAdmin')
    if (!adminEditOnly) return true

    return !adminEditOnly.includes(field) || (adminEditOnly.includes(field) && isAdmin)
  }

  isSectionIncluded () {
    const { data, fields, metadata } = this.props
    const genUseTM = data.get('genUseTM')

    if (!genUseTM) return true

    return fields.some(field => {
      const fieldMetadata = metadata.get(field)
      if (!fieldMetadata) return false

      const include = fieldMetadata.get('include')
      return !include.size || // Include all
        genUseTM.some(t => include.includes(t)) // Include one of genUseTM types
    })
  }

  isFieldsIncludedSfr () {
    const { account, fields } = this.props
    const group = account.get('group')
    if (!group.get('isSfr')) return true

    return !fields.every(field => isFieldHiddenSfr(field))
  }

  renderTable () {
    const { account, editable, data, errors, link, fields, metadata, onCertify } = this.props
    if (!fields || !fields.size) return null

    return (
      <Table bordered className="redi-component-editable-table">
        <tbody>
          {fields.filter((field) => field).map((field, key) => (
            <TRow
              account={account}
              editable={editable && this.checkAdminFields(field)}
              key={key}
              errors={errors}
              fieldMetadata={metadata.get(field)}
              field={field}
              genUseTM={data.get('genUseTM')}
              fieldData={data.getIn(['fieldData', field])}
              userMap={data.get('userMap')}
              isPrivate={data.get('isPrivate')}
              isLocked={data.has('pointsWorth')}
              onCertify={onCertify}
              value={data.get(field) /* this exists so immutable render knows change */}
              link={link} />
          ))}
        </tbody>
      </Table>
    )
  }

  render() {
    if (!this.isSectionIncluded()) return null
    if (!this.isFieldsIncludedSfr()) return null

    return (
      <div>
        {this.renderTitle()}
        {this.renderTable()}
      </div>
    )
  }
}

export default EditableTable



// WEBPACK FOOTER //
// ./modules/shared/components/editableTable.js